import { PiUsersThreeThin } from 'react-icons/pi';
import { Box, Grid } from '@mui/material';
import { IoWaterOutline } from "react-icons/io5";
import { MdOutlineSendToMobile } from "react-icons/md";
import { MdDesktopAccessDisabled } from "react-icons/md";
import { useClock } from '../context/ClockProvider';
import useFetchData from '../helpers/useFetch';
import AppURL from '../constants/AppURL';
import { StatCard } from '../components/application/create/dashboard/StatCard';
import { VscVmActive } from "react-icons/vsc";
import { FaUsersGear } from "react-icons/fa6";
import ChartDashboard from '../components/application/create/dashboard/ChartStats';
import SpeedometerGauge from '../components/application/create/dashboard/ProgressBar';
import Container from '../constants/Container';
import HorizontalChart from '../components/application/create/dashboard/HorizontalChart';
import PreviousComp from '../components/application/create/dashboard/PreviousComp';


const MainDashboardView = () => {
  const { data, loading, error } = useFetchData(AppURL.ApplicationURL + 'app/dashboard/details/list/view/');

  return (
    <div className='gap-y-3'>
      <Grid container spacing={1}>
        <Grid item xl={2} lg={4} sm={12} md={4} xs={12}>
          <StatCard title='Total Customer' icon={<PiUsersThreeThin size={16} />} value={'1200'} change={'23'} changeType={'up'} color={'red'} />
        </Grid>
        <Grid item xl={2} lg={4} sm={12} md={4} xs={12}>
          <StatCard title='Active Customer' icon={<VscVmActive size={16} />} value={'12'} change={'23'} changeType={'up'} color={'red'} />
        </Grid>
        <Grid item xl={2} lg={4} sm={12} md={4} xs={12}>
          <StatCard title='Inactive Customer' icon={<MdDesktopAccessDisabled size={16} />} value={'70'} change={'23'} changeType={'up'} color={'red'} />
        </Grid>
        <Grid item xl={2} lg={4} sm={12} md={4} xs={12}>
          <StatCard title='Total Reader' icon={<MdOutlineSendToMobile size={16} />} value={'144'} change={'23'} changeType={'up'} color={'red'} />
        </Grid>
        <Grid item xl={2} lg={4} sm={12} md={4} xs={12}>
          <StatCard title='Total Staff' icon={<FaUsersGear size={16} />} value={'45'} change={'23'} changeType={'up'} color={'red'} />
        </Grid>
        <Grid item xl={2} lg={4} sm={12} md={4} xs={12}>
          <StatCard title='Total Active Taps' icon={<IoWaterOutline size={16} />} value={'42'} change={'23'} changeType={'down'} color={'red'} />
        </Grid>
        <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
          <Grid container spacing={1} alignItems="stretch">
            <Grid item xl={9} lg={9} sm={12} md={12} xs={12}>
              <ChartDashboard />
            </Grid>

            <Grid item xl={3} lg={3} sm={12} md={12} xs={12}>
              <div className='border border-slate-200 h-full flex justify-center items-center bg-white rounded-md'>
                <SpeedometerGauge />
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
          <Grid container spacing={1} alignItems="stretch">
            <Grid item xl={6} lg={6} sm={12} md={12} xs={12}>
              <HorizontalChart />
            </Grid>
            <Grid item xl={6} lg={6} sm={12} md={12} xs={12}>
              <PreviousComp />
            </Grid>

          </Grid>
        </Grid>
      </Grid>
    </div >
  )
}

export default MainDashboardView